var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card card-primary card-outline" }, [
    _c("div", { staticClass: "card-body" }, [
      _c("p", [
        _vm._v(
          "\n            If you would like to contact us, please write a short message below and click the button. We will be in touch as soon as possible.\n        "
        ),
      ]),
      _vm._v(" "),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.form.message,
            expression: "form.message",
          },
        ],
        staticClass: "form-control",
        class: { "is-invalid": _vm.errors.message },
        attrs: { rows: "5" },
        domProps: { value: _vm.form.message },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.form, "message", $event.target.value)
          },
        },
      }),
      _vm._v(" "),
      _vm.errors.message
        ? _c("div", { staticClass: "invalid-feedback" }, [
            _vm._v(
              "\n            " + _vm._s(_vm.errors.message) + "\n        "
            ),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-footer clearfix" }, [
      _vm.loading
        ? _c("div", [
            _c(
              "button",
              {
                staticClass: "btn btn-danger float-left",
                attrs: { disabled: "" },
              },
              [_vm._v("Cancel")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "divider" }),
            _vm._v(" "),
            _vm._m(0),
          ])
        : _c("div", [
            _c(
              "a",
              {
                staticClass: "btn btn-danger float-left",
                attrs: {
                  type: "button",
                  href: "/projects/" + this.project_id + "/profile",
                },
              },
              [_vm._v("Cancel")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "divider" }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary float-right",
                on: { click: _vm.onSubmit },
              },
              [_c("i", { staticClass: "fas fa-save" }), _vm._v(" Submit")]
            ),
          ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      { staticClass: "btn btn-primary float-right", attrs: { disabled: "" } },
      [_c("i", { staticClass: "fas fa-spin fa-spinner" }), _vm._v(" Submit")]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }